// @flow
import React, { useState } from 'react';
import {
  Input,
  Select,
  Modal,
} from 'antd';
import { SpH5, SpButton } from 'components/DesignKit';

import { ROLES } from 'appconstants';

const { Option } = Select;

type Props = {
  roles: Array<Object>,
  visible: boolean,
  close: Function,
  submit: Function,
  selectedUser: {
    user: Object,
    role: Object,
  },
};

const EditUser = (props: Props) => {
  const {
    roles,
    visible,
    close,
    submit,
    selectedUser,
  } = props;

  const [role, setRole] = useState(selectedUser && selectedUser.role && selectedUser.role.gid);

  const validate = (event) => {
    event.preventDefault();
    submit({
      firstName: selectedUser.user.givenName,
      lastName: selectedUser.user.familyName,
      email: selectedUser.user.email,
      role,
    });
  };

  return (
    <Modal
      centered
      closable={false}
      visible={visible}
      footer={[
        <SpButton onClick={() => close()} type="secondary">Cancel</SpButton>,
        <SpButton onClick={validate}>Update</SpButton>,
      ]}
      title="Update Team Member"
    >
      <div className="px-4">
        <div className="d-flex">
          <div className="mb-3 mr-3">
            <label htmlFor=""><SpH5>First Name</SpH5></label>
            <Input
              placeholder="First name"
              value={selectedUser.user.givenName}
              disabled
            />
          </div>

          <div className="mb-3">
            <label htmlFor=""><SpH5>Last Name</SpH5></label>
            <Input
              placeholder="Last name"
              value={selectedUser.user.familyName}
              disabled
            />
          </div>
        </div>

        <div className="mb-3">
          <label htmlFor=""><SpH5>Account Email</SpH5></label>
          <Input
            placeholder="User Email"
            value={selectedUser.user.email}
            disabled
          />
        </div>

        <div className="pb-3">
          <label className="d-block"><SpH5>Assign Role</SpH5></label>
          <Select
            style={{ width: '50%' }}
            placeholder="Please select"
            className="text-capitalize"
            // eslint-disable-next-line max-len
            defaultValue={selectedUser.role.name === 'KDS-USER' ? 'KdsUser' : selectedUser.role.name === 'KDS-ADMIN' ? 'KdsAdmin' : selectedUser.role.name}
            onChange={(value) => setRole(value)}
          >
            {
              roles.filter(allRoles => !(allRoles.name === ROLES.OWNER || allRoles.name === ROLES.DEVICE)).map(r => (
                <Option
                  key={1}
                  value={r.gid}
                  className="text-capitalize"
                >
                  {r.name === 'KDS-USER' ? 'KdsUser' : r.name === 'KDS-ADMIN' ? 'KdsAdmin' : r.name}
                </Option>
              ))
            }
          </Select>
        </div>
      </div>
    </Modal>
  );
};

export default EditUser;
